module.exports = __webpack_public_path__ + "img/9788957691397.c63d8295.jpg";